import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import './UserNavigator.scss';

const UserNavigatorSkeleton = () => {
  const baseColor = '#E7EAFF'; // Darker base color
  const highlightColor = '#dce1fc'; // Slightly lighter highlight
  return (
    <FlexboxColumn gap='1.25rem' fw>
      {/* Top Section */}
      <Flexbox justifyContent='space-between' className='usernavigator_wrapper__content' fw>
        {/* Left: User Info */}
        <Flexbox gap='1rem' className='usernavigator_wrapper__content'>
          <Skeleton borderRadius={'1rem'} width={'6.25rem'} height={'6.25rem'} className='usernavigator_wrapper__userImage' baseColor={baseColor} highlightColor={highlightColor} />
          <FlexboxColumn alignItems='flex-start' gap='1rem' justifyContent='space-between'>
            <div>
              <Skeleton width={120} height={30} baseColor={baseColor} highlightColor={highlightColor} />
              <Skeleton width={80} height={20} baseColor={baseColor} highlightColor={highlightColor} className='usernavigator_wrapper__details' />
            </div>
            <Flexbox gap='0.15rem'>
              {/* <Skeleton width={20} height={20} baseColor={baseColor} highlightColor={highlightColor} /> */}
              <Skeleton width={240} height={18} baseColor={baseColor} highlightColor={highlightColor} className='usernavigator_wrapper__details' />
            </Flexbox>
          </FlexboxColumn>
        </Flexbox>
      </Flexbox>
    </FlexboxColumn>
  );
};

export default UserNavigatorSkeleton;
